import { Vue, Component } from 'vue-property-decorator';

@Component
export default class AdvantagesSection extends Vue {
  openComparisonChart() {
    window.open(process.env.COMPARISON_CHART_LINK, '_blank');
  }
}
